import { get, isEmpty, isNil, forOwn } from 'lodash';
import { CONFIRM_TEXT } from '../constants';

export const getRecommendations = recommendations =>
  recommendations.map(recommendation => ({
    label: get(recommendation, 'recommCode.dn', ''),
    description: get(recommendation, 'recommText', ''),
    currentStage: recommendation.currentStage,
    numStages: recommendation.numStages,
    feedback: recommendation.feedback,
    recommendatinTypes: get(recommendation, 'resolutionTypes', []).map(
      resolutionType => resolutionType.dn,
    ),
    showChip: recommendation.feedback === 'CONFIRM',
    urgency: recommendation.urgency.id,
  }));

export const getResolutionTypewithCount = recommendation => {
  const data = recommendation.reduce((acc, resolutionTypeItems) => {
    if (!isEmpty(resolutionTypeItems.resolutionTypes)) {
      resolutionTypeItems.resolutionTypes.forEach(resolutionType => {
        acc[resolutionType.dn] = (acc[resolutionType.dn] || 0) + 1;
      });
    }
    return acc;
  }, {});
  return data;
};

// eslint-disable-next-line consistent-return
export const getResolutionType = resolution => {
  if (!isEmpty(resolution) && !isNil(resolution))
    return resolution.map(resoln => resoln.dn);
};

// eslint-disable-next-line consistent-return
export const getResolutionTypeId = resolution => {
  if (!isEmpty(resolution) && !isNil(resolution))
    return resolution.map(resoln => resoln.id);
};

export const getResolutionTypeWithNonEmptyItem = recommendations => {
  const resolutionTypesForARecommendation = [];
  recommendations.forEach(recomm => {
    if (!isEmpty(recomm.resolutionTypes) && !isNil(recomm.resolutionTypes)) {
      recomm.resolutionTypes.forEach(resolutionType => {
        resolutionTypesForARecommendation.push(resolutionType.dn);
      });
    }
  });
  return resolutionTypesForARecommendation;
};

export const getFormattedResolutionTypeCount = resolutionData => {
  const formattedResolutionTypeCount = [];
  forOwn(resolutionData, (value, key) => {
    const resolutionTypeCount = { resolutionType: '', count: 0 };
    resolutionTypeCount.resolutionType = key;
    resolutionTypeCount.count = value;
    formattedResolutionTypeCount.push(resolutionTypeCount);
  });
  return formattedResolutionTypeCount;
};

export const getAssetCountByResolutionType = recommendation =>
  recommendation.map(paiResolutionType =>
    paiResolutionType.resolutionTypes.map(reslType => reslType.dn),
  );

export const getResolutionTypesForAnAsset = recommendations => {
  const resolutionTypesArr = [];
  recommendations?.forEach(reco => {
    reco.resolutionTypes.forEach(resolutionType => {
      if (!resolutionTypesArr.includes(resolutionType.dn)) {
        resolutionTypesArr.push(resolutionType.dn);
      }
    });
  });
  return resolutionTypesArr;
};

export const getConfirmCount = recommendations =>
  recommendations.reduce(
    (acc, recomm) =>
      recomm.feedback.toLowerCase() === CONFIRM_TEXT ? acc + 1 : acc,
    0,
  );
